import React from "react";
import { useState , useEffect } from "react";
import validatorIndex from "../../../utilities/validators/validatorIndex.js";
import RequirementsComponent from "./requirementsComponent";
import TwrRefOptions from "./twrRefOption";

function TwrPathRequirement(props)
    {

    const [requirements, setRequirements]=useState()
    const [requirementsText,setRequirementsText]=useState()
    const [component, setComponent]=useState()
    const [requirementsMet, setRequirementsMet]=useState(false)


    const clickFunction=()=>
    {setRequirementsMet(true)}
   
        useEffect(()=>
            {
            const findRequirements=()=>
            {
                let requirements =""
                validatorIndex[props.pathway]["requirements"].forEach((item)=>
                {
                requirements += `${item}, `
                })
                setRequirements(requirements)
            }
            
            findRequirements()
            if (requirements==="")
                {setRequirementsMet(true)}
            else
                {
                setRequirementsText(`The requirements for referral under the ${props.readablePath} pathway are ${requirements} If the patient is Warfarin please also arrange an INR.`  )
                }  
                
        let componentToSet = (requirementsMet ? <TwrRefOptions pathway={props.pathway} readablePath = {props.readablePath}/>: <RequirementsComponent requirementsText={requirementsText}  clickFunction={clickFunction}/>)
        setComponent(componentToSet)

        },[requirementsText,requirements,requirementsMet])

      
    return( <div>
    <span>The Patient's symptoms meet the NICE criteria for {props.readablePath} Two Week Rule Referral</span>
    <br/><br/>
    <div>{component}</div>
    </div>
    )
    }

export default TwrPathRequirement





 